const classPrefix = 'modal-template-register-final';
const dataPrefix = 'data-modal-template-register-final';

export function modalTemplateRegisterFinal($container, params = {userId: null}) {
    const $template = document.querySelector(`[${dataPrefix}-template]`)

    init();
    function init(){
        const $modalClone = document.importNode($template.content, true)

        const $form = $modalClone.querySelector(`[${dataPrefix}-form]`);
        const $restore = $modalClone.querySelector(`[${dataPrefix}-restore]`);
        const $confirm = $modalClone.querySelector(`[${dataPrefix}-confirm]`);

        $confirm.addEventListener('click', () => {
            console.log('params', params)

            window.location.href = `https://t.me/psyhologiumQ_bot?start=reg_${params.userId}`
        });

        $container.appendChild($modalClone)
    }



}
